export var DateSpan;
(function (DateSpan) {
    function is(value) {
        return (typeof value == "object" &&
            (typeof value.years == "number" || value.years == undefined) &&
            (typeof value.months == "number" || value.months == undefined) &&
            (typeof value.days == "number" || value.days == undefined) &&
            (typeof value.years == "number" || typeof value.months == "number" || typeof value.days == "number"));
    }
    DateSpan.is = is;
})(DateSpan || (DateSpan = {}));
//# sourceMappingURL=DateSpan.js.map